import { render, staticRenderFns } from "./SpaceAvatar.vue?vue&type=template&id=96be96e2&scoped=true&"
import script from "./SpaceAvatar.vue?vue&type=script&lang=js&"
export * from "./SpaceAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SpaceAvatar.vue?vue&type=style&index=0&id=96be96e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96be96e2",
  null
  
)

export default component.exports